module.exports = __webpack_public_path__ + "img/unAvatar.03cfb6ab.png";